<template>
  <b-container fluid>
    <form @submit.prevent="saveData">
      <b-row>
        <b-col sm="12">
          <card>
            <template v-slot:headerTitle>
              <h4 class="card-title"><b>CREAR EMPRESA</b></h4>
            </template>
            <h4 class="px-4 py-4"><b>Información General</b></h4>
            <div class="row px-5">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label">Nombre</label>
                  <input required v-model="item.nombre" placeholder="nombre" type="text" class="form-control" id="exampleFormControlInput1" />
                </div>
              </div>
              <div class="col-md-6 mb-4">
                <div>
                  <label for="exampleFormControlInput1" class="form-label">Sector</label>
                  <b-form-select required @change.native="actualizaSector($event)"  value-field="id" text-field="descripcion" :options="ListSector"></b-form-select>
                </div>
              </div>
            </div>
          </card>
        </b-col>
        <b-col sm="12">
          <card>
            <template v-slot:headerTitle>
              <h4 class="card-title"><b>Información Contacto</b></h4>
            </template>

            <div class="row px-5 mt-3">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="nombre" class="form-label">Nombre Contacto</label>
                  <input required v-model="item.nombreContacto" placeholder="Escriba el Nombre del Contacto..." type="text" class="form-control" id="nombre" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="telefonoContacto" class="form-label">Número Contacto</label>
                  <input required v-model="item.telefonoContacto" placeholder="Escriba el Número del Contacto..." type="text" class="form-control" id="telefonoContacto" />
                </div>
              </div>

              <div class="col-md-6">
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label">Correo Electrónico</label>
                  <input required v-model="item.correo" placeholder="Escriba el Correo Electronico..." type="email" class="form-control" id="exampleFormControlInput1" />
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label">Contraseña para IFrames</label>
                  <input required v-model="item.contrasenaIFrame" placeholder="Escriba la Contraseña..." type="text" class="form-control" id="exampleFormControlInput1" />
                </div>
              </div>
            </div>
            <div class="text-right px-5 pb-4 d-flex justify-content-end">
               <vs-button
                 gradient
                 primary
                 icon
                 animation-type="vertical"
                 type="submit"
                 class="mx-1 "
               >
                 <i class="fas fa-save pr-1" ></i> 
                 Guardar Información
                 <template #animate >
                   <i class="fas fa-save" ></i> 
                 </template>
               </vs-button>
               <vs-button
                 gradient
                 danger
                 icon
                 animation-type="vertical"
                 class="mx-1"
                 @click="$router.push('/helex/empresa')"
               >
                 <i class="fas fa-xmark pr-1" ></i> 
                 Cancelar
                 <template #animate >
                   <i class="fas fa-xmark" ></i> 
                 </template>
               </vs-button>
            </div>
          </card>
        </b-col>
      </b-row>
    </form>
  </b-container>
</template>
<script>
//  import { core } from "../../../config/pluginInit";
export default {
  name: "DataTable",
  data() {
    return {
      item: {},
      id: "",
      options: {},
      ListSector: [],
    };
  },
  async mounted() {
  //   core.index();
    await this.getListSector();
  },
  methods: {
   actualizaSector(e){
      console.log(e.target.value)
      this.item.sectorId = e.target.value
   },
    async getListSector() {
       try {
        let res = await this.$store.dispatch("hl_post", {
          path: "Sector/ListSector/",
         });
         this.ListSector = res;

        console.log('list',this.ListSector);
      } catch (error) {
         this.ListSector = {};
         console.log("err", error);
      }
   },
   async saveData() {
     console.log('saving', this.item);
     try {
       let res = await this.$store.dispatch("hl_post", {
         path: "Empresa/Create/", data: this.item
       });
       console.log("post empresas...", res);
       if(res)
         this.$router.push('/helex/empresa')
      else
       alert('Verificar')
       
     } catch (error) {
       this.item = {};
       console.log("err", error);
     }
   },
},
};
</script>
